export const environment = {
  production: true,
  piwikId: '488',
  piwikUrl: '//statistiek.rijksoverheid.nl/piwik/',
  piwikDomains: ['*.bigregister.nl'],
  piwikCookieDomain: '*.bigregister.nl'
};
